import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import useRecurringCleaningPromo from '@front/customer/src/hooks/use-recurring-cleaning-promo';

import { translate } from '@front/i18n';

import Modal from '@front/web-ui/src/components/modal/modal';
import Text from '@front/web-ui/src/components/base-text/variants/text';

import { RootState } from '../../store';

const ModalContent = styled.div`
  padding: 0 20px 20px;
`;

const t = translate('basket.cleaning.modal.alert_promo_code');

const CleaningPromoModal = () => {
  const cleaningPrestation = useSelector((state: RootState) => state.basket.cleaningPrestation);
  const promotion = useSelector((state: RootState) => state.basket.promotion);
  const { isOpen, close } = useRecurringCleaningPromo({
    isPromotionValid: promotion?.success,
    cleaningPrestation,
  });

  return (
    <Modal
      title={t('.title')}
      isOpen={isOpen}
      onClose={close}
      primaryButton={{
        children: t('.button'),
        onPress: close,
      }}
    >
      <ModalContent>
        <Text>{t('.after_choosing_frequency')}</Text>
      </ModalContent>
    </Modal>
  );
};

export default CleaningPromoModal;
